import React from 'react';
import PropTypes from 'prop-types';
import { batch, useDispatch } from 'react-redux';

import TableHead from '../../../../components/Table/TableHead';
import TableRow from '../../../../components/Table/TableRow';
import TableHeadData from '../../../../components/Table/TableHeadData';
import TableBody from '../../../../components/Table/TableBody';
import EmptyTable from '../../../../components/Table/EmptyTable';
import Table from '../../../../components/Table/Table';
import Checkbox from '../../../../components/Checkbox/Checkbox';
import UserRow from './UserRow';
import { permissions } from '../../../../common/permissionGroup';
import PermissionsGate from '../../../../components/PermissionsGate/PermissionsGate';
import getUsers from '../../../../thunks/users/getUsers';
import accountStatus from '../../../../constants/accountStatus';
import patchUserData from '../../../../thunks/users/patchUserData';

const UsersTable = ({ users }) => {
  const dispatch = useDispatch();
  const actionList = [
    {
      id: 1,
      title: 'Block user',
      onClick: ({ id }) => {
        batch(() => {
          dispatch(patchUserData({ userId: id, account_status: accountStatus.DISABLED }));
          dispatch(getUsers());
        });
      },
      danger: true
    },
    {
      id: 2,
      title: 'Activate user',
      onClick: ({ id }) => {
        batch(() => {
          dispatch(patchUserData({ userId: id, account_status: accountStatus.ACTIVE }));
          dispatch(getUsers());
        });
      },
    }
  ];
  return (
    <Table>
      <TableHead>
        <TableRow bordered>
          <TableHeadData>
            <Checkbox name="select_all" />
          </TableHeadData>
          <TableHeadData>
            user
          </TableHeadData>
          <TableHeadData>
            Role
          </TableHeadData>
          <TableHeadData>
            Status
          </TableHeadData>
          <TableHeadData>
            2FA
          </TableHeadData>
          <TableHeadData>
            Last Login
          </TableHeadData>
          <TableHeadData>
            Joined Date
          </TableHeadData>
          <PermissionsGate can={permissions.USERS_UPDATE}>
            <TableHeadData>
              Actions
            </TableHeadData>
          </PermissionsGate>
        </TableRow>
      </TableHead>
      <TableBody>
        {users?.length ? users?.map((user, index) => (
          <UserRow
            user={user}
            key={user.id}
            bordered={index !== users.length - 1}
            actionList={actionList}
          />
        )) : <EmptyTable colSpan={7} text="No any users find" />}
      </TableBody>
    </Table>
  );
};

UsersTable.propTypes = {
  users: PropTypes.arrayOf(PropTypes.shape({}))
};

UsersTable.defaultProps = {
  users: []
};

export default UsersTable;
